import React, { useState, useEffect } from 'react';
import { GetDashboardData } from '../services/dashboardservice';
function Dashboard() {
    const [data, setData] = useState([]);
    const [userFullName, setUserFullName] = useState(null);
    useEffect(() => {
        const username = localStorage.getItem('fullname');
        if (username) {
            setUserFullName(username);
        }
        const response = fillData();
    }, []);

    const fillData = async () => {
        try {
            const dashboardData = await GetDashboardData();
            const dashboardCount = JSON.parse(dashboardData);
            setData(dashboardCount);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    return (
        <>
            <div class="row">
                <div class="col-md-12 grid-margin">
                    <div class="row">
                        <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                            <h3 class="font-weight-bold">Welcome {userFullName}</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 grid-margin transparent">
                    <div class="row">
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-tale">
                                <div class="card-body">
                                    <p class="mb-4">Published Post</p>
                                    <p class="fs-30 mb-2">{data.publishedpostcount}</p>
                                    {/* <p>10.00% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-dark-blue">
                                <div class="card-body">
                                    <p class="mb-4">Draft Post</p>
                                    <p class="fs-30 mb-2">{data.draftpostcount}</p>
                                    {/* <p>22.00% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-light-blue">
                                <div class="card-body">
                                    <p class="mb-4">Categories</p>
                                    <p class="fs-30 mb-2">{data.categorycount}</p>
                                    {/* <p>2.00% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-light-danger">
                                <div class="card-body">
                                    <p class="mb-4">Tags</p>
                                    <p class="fs-30 mb-2">{data.tagscount}</p>
                                    {/* <p>0.22% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 grid-margin transparent">
                    <div class="row">
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-tale">
                                <div class="card-body">
                                    <p class="mb-4">Users</p>
                                    <p class="fs-30 mb-2">{data.usercount}</p>
                                    {/* <p>10.00% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-dark-blue">
                                <div class="card-body">
                                    <p class="mb-4">Media Image</p>
                                    <p class="fs-30 mb-2">{data.mediacount}</p>
                                    {/* <p>22.00% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-light-blue">
                                <div class="card-body">
                                    <p class="mb-4">Subject Count</p>
                                    <p class="fs-30 mb-2">{data.subjectcount}</p>
                                    {/* <p>2.00% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 mb-4 stretch-card transparent">
                            <div class="card card-light-danger">
                                <div class="card-body">
                                    <p class="mb-4">Question Count</p>
                                    <p class="fs-30 mb-2">{data.questioncount}</p>
                                    {/* <p>0.22% (30 days)</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
